<div class="mapa-navbar-container">
    <div *ngIf="!(isHandset$ | async)" class="mapa-navbar-desktop">
        <p-menubar [model]="nav" [styleClass]="'mapa-menubar'"></p-menubar>
        <mapa-search-nav-item (changeRouter)="fecharMenuLateral($event)"></mapa-search-nav-item>
        <p-dropdown (onChange)="atualizarIdioma()" *ngIf="languages.length > 0" [(ngModel)]="language"
                    [options]="languages"
                    [styleClass]="'mapa-lang'" placeholder="Language"></p-dropdown>
        <p-menubar [autoDisplay]="false" [model]="navRight" [styleClass]="'mapa-menubar'"></p-menubar>
    </div>
    <div *ngIf="isHandset$ | async" class="mapa-navbar-mobile">
        <p-sidebar [(visible)]="exibirMenuLateral" [showCloseIcon]="false" [styleClass]="'mapa-menubar-mobile-sidebar'">
            <div class="mapa-menubar-mobile-head">
                <div>
                    <ngx-avatar [name]="usuario ? usuario.nome : 'MAPA'" initialsSize="2" size="80"></ngx-avatar>
                </div>
                <div>
               <span
                   class="mapa-dados-login-val">{{usuario ? usuario.nome : 'CORE.HEADER.NOT_AUTHENTICATED' | translate}}</span>
                </div>
            </div>
            <div class="mapa-menubar-mobile-content">
                <div class="mapa-menubar-mobile-search-nav-item">
                    <mapa-search-nav-item (changeRouter)="fecharMenuLateral($event)"></mapa-search-nav-item>
                </div>
                <div class="mapa-menubar-mobile-lang">
                    <p-dropdown (onChange)="atualizarIdioma()" *ngIf="languages.length > 0" [(ngModel)]="language"
                                [options]="languages"
                                placeholder="Language"></p-dropdown>
                </div>
                <p-panelMenu [model]="nav" [styleClass]="'mapa-menubar-mobile-nav'"></p-panelMenu>
                <p-panelMenu [model]="navRight" [styleClass]="'mapa-menubar-mobile-nav'"></p-panelMenu>
            </div>
        </p-sidebar>
        <button (click)="exibirMenuLateral = true" icon="pi pi-bars" pButton type="text"></button>
        <h1>{{appName}}</h1>
    </div>

</div>
